import * as _4 from 'lodash4';
import { APProgramInfoQuery } from '../../../../../plan/queries/ap_program_info_query';
import { HiComponentAttributeChangedEvent } from './../../../../../global/types/common_types';

class MmDegreeMapInstructionsComponent {
  private expanded: boolean = false;
  constructor(private ngAPProgramInfoQuery: APProgramInfoQuery) {}

  instructionsToggled(event: HiComponentAttributeChangedEvent) {
    this.expanded = event.detail.value;
  }
}

angular.module('capability-ng-academic-planner').component('mmDegreeMapInstructionsComponent', {
  templateUrl:
    'capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_instructions_component/mm_degree_map_instructions_component.html',
  controller: MmDegreeMapInstructionsComponent
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_instructions_component/mm_degree_map_instructions_component.ts